<template>
    <body id="app">

    <transition name="fade" mode="out-in">
        <router-view class="view"></router-view>
    </transition>

    </body>
</template>

<script>
    export default {
        components: {

        },
        data: function () {
            return {
                props: Application.props,
            }
        },
        created: function () {

        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?e5813d58